/* SNZ-SIZE-PRICES, 12 Oct 2026 (Z): the price on each size / pack button.
 *
 * WHY: Clarity (5-11 Oct) showed cushion visitors tapping size pills ~90 times
 * on mobile product pages but Add to cart only 3 times. One set ran from
 * £25.90 to £41.90 across its sizes, and the only way to see a price was to
 * tap each pill and read the price block. Now each pill says what it costs.
 *
 * Prices are never computed here: sections/snz-free-returns.liquid prints every
 * variant's options and its `| money` price into #snz-pp-data, and this file only
 * looks them up. For an option (e.g. "Pack") it shows, on each value, the price
 * of the variant you would get by picking that value with your other choices
 * kept. An option whose values all cost the same (e.g. "Colour") gets no prices,
 * so colour rows stay clean. Unavailable combinations get no price.
 * Dawn re-renders the pills on every variant change, so this re-applies itself
 * (variantChange + a MutationObserver), and it is idempotent.
 * Revert = delete the script line in sections/snz-free-returns.liquid.
 */
(function () {
  'use strict';
  if (window.__snzSizePrices) return;
  window.__snzSizePrices = true;

  var data = null;
  try { data = JSON.parse((document.getElementById('snz-pp-data') || {}).textContent || 'null'); } catch (e) { return; }
  if (!data || !data.length) return;

  var css = document.createElement('style');
  css.textContent =
    'variant-selects .snz-pp{margin-left:.3rem;font-variant-numeric:tabular-nums;opacity:.72;font-weight:500;white-space:nowrap}' +
    'variant-selects input:checked + label .snz-pp{opacity:.9}';
  (document.head || document.documentElement).appendChild(css);

  function norm(s) { return String(s == null ? '' : s).trim(); }

  function find(opts) {
    for (var i = 0; i < data.length; i++) {
      var o = data[i].o, ok = true;
      for (var k = 0; k < opts.length; k++) { if (norm(o[k]) !== norm(opts[k])) { ok = false; break; } }
      if (ok) return data[i];
    }
    return null;
  }

  /* 1 Nov 2026: a button whose own label already IS the price (gift card "£25") gets no price tag,
     otherwise it read "£25 £25.00". Compares the numbers, so "£25" equals "£25.00". */
  function amount(s) {
    var m = String(s == null ? '' : s).replace(/,/g, '').match(/^\s*[£€$]?\s*(\d+(?:\.\d+)?)\s*$/);
    return m ? Math.round(parseFloat(m[1]) * 100) : null;
  }

  function apply() {
    var vs = document.querySelector('product-info variant-selects') || document.querySelector('variant-selects');
    if (!vs) return;
    var sets = Array.prototype.slice.call(vs.querySelectorAll('fieldset.product-form__input--pill'));
    if (!sets.length) return;
    /* current choice per option, in fieldset (= option position) order */
    var cur = sets.map(function (fs) {
      var c = fs.querySelector('input[type="radio"]:checked');
      return c ? c.value : '';
    });
    if (cur.length !== (data[0].o || []).length) return; /* a select dropdown is mixed in: don't guess */
    sets.forEach(function (fs, idx) {
      var inputs = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]'));
      var rows = inputs.map(function (inp) {
        var opts = cur.slice(); opts[idx] = inp.value;
        return { inp: inp, v: find(opts) };
      });
      var distinct = {};
      rows.forEach(function (r) { if (r.v) distinct[r.v.c] = 1; });
      var show = Object.keys(distinct).length > 1;
      rows.forEach(function (r) {
        var label = fs.querySelector('label[for="' + r.inp.id + '"]');
        if (!label) return;
        var tag = label.querySelector('.snz-pp');
        var want = show && r.v && r.v.a !== false ? ' ' + r.v.p : '';
        if (want && amount(r.inp.value) !== null && amount(r.inp.value) === amount(r.v.p)) want = ''; /* leading space: read as "cm, £29.90" not "cm£29.90" */
        if (!want) { if (tag) tag.remove(); return; }
        if (!tag) {
          tag = document.createElement('span');
          tag.className = 'snz-pp';
          var hid = label.querySelector('.visually-hidden');
          label.insertBefore(tag, hid || null);
        }
        if (tag.textContent !== want) tag.textContent = want;
      });
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; try { apply(); } catch (e) {} });
  }

  function boot() {
    schedule();
    var host = document.querySelector('product-info') || document.body;
    try { new MutationObserver(schedule).observe(host, { childList: true, subtree: true }); } catch (e) {}
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) schedule();
    });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      try { subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(schedule, 0); }); } catch (e) {}
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
